import styled from 'styled-components'

import { ResponsiveImage, fromLg } from '@syconium/little-miss-figgy'

export const ShopTheLookTileImage = styled(ResponsiveImage)`
  height: 85px;
  width: 85px;

  ${fromLg} {
    height: 250px;
    width: 200px;
  }
`
